import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FiArrowUpRight } from 'react-icons/fi';

const publications = [
  {
    publication: 'HousingWire',
    title: 'The first 15 minutes that cost brokerages revenue',
    description: 'Why brokerage conversion depends less on lead volume and more on what happens immediately after an inquiry arrives.',
    url: 'https://www.housingwire.com/articles/the-first-15-minutes-that-cost-brokerages-revenue/',
    secondaryLabel: 'Author profile',
    secondaryUrl: 'https://www.housingwire.com/author/anu-singh/'
  },
  {
    publication: 'Entrepreneur Middle East',
    title: 'Why Speed, Not Persuasion, Is the Real Problem in Real Estate Sales',
    description: 'A perspective on why real estate sales teams lose momentum when buyer questions and intent move faster than the systems behind them.',
    url: 'https://mena.entrepreneur.com/business-news/why-speed-not-persuasion-is-the-real-problem-in-real-estate-sales'
  }
];

const Publications = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <section className="section-padding bg-off-white">
      <motion.div
        ref={ref}
        initial={{ opacity: 0, y: 24 }}
        animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 24 }}
        transition={{ duration: 0.6 }}
        className="container-custom"
      >
        <div className="max-w-5xl mx-auto">
          <div className="max-w-3xl mb-12">
            <p className="text-sm uppercase tracking-[0.2em] text-gold font-semibold mb-3">Perspectives &amp; Publications</p>
            <h2 className="text-4xl md:text-5xl font-serif text-navy mb-5">Writing about the systems behind the sale.</h2>
            <p className="text-lg text-charcoal leading-relaxed">
              I write about AI, PropTech and how technology is changing buyer behaviour, sales operations and the infrastructure behind the real estate journey.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {publications.map((item) => (
              <article key={item.url} className="bg-white rounded-xl p-7 md:p-8 border border-gray-100 shadow-sm flex flex-col">
                <p className="text-sm font-semibold text-gold uppercase tracking-[0.16em] mb-4">{item.publication}</p>
                <h3 className="text-2xl font-serif text-navy mb-4">{item.title}</h3>
                <p className="text-charcoal leading-relaxed mb-7 flex-grow">{item.description}</p>
                <div className="flex flex-wrap items-center gap-5">
                  <a
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 text-navy font-medium hover:text-gold"
                  >
                    Read article <FiArrowUpRight />
                  </a>
                  {item.secondaryUrl && (
                    <a
                      href={item.secondaryUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm text-charcoal/70 hover:text-gold"
                    >
                      {item.secondaryLabel}
                    </a>
                  )}
                </div>
              </article>
            ))}
          </div>

          <div className="mt-8">
            <a href="/insights" className="inline-flex items-center gap-2 text-navy font-medium hover:text-gold">
              Read my independent insights <FiArrowUpRight />
            </a>
          </div>
        </div>
      </motion.div>
    </section>
  );
};

export default Publications;
